import React, { useState } from 'react';
import { motion } from 'framer-motion';
import TextScramble from './TextScramble';
import ScrollTimeline from './ScrollTimeline';
import TechMarquee from './TechMarquee';
import ProjectsShowcase from './ProjectsShowcase';
import './Portfolio.css';

function Portfolio() {
    // Timeline data
    const timelineEvents = [
        {
            year: '2020',
            title: 'Completed 10th Grade',
            description: 'Completed 10th standard from CMA Hr Sec School, Satna (M.P), India - CBSE Board. Scored <strong>70%</strong>.',
            position: 100,
            curveX: 230, // X position on curve
            image: '/images/cma_campus.jpg',
        },
        {
            year: '2022',
            title: 'Completed 12th Grade',
            description: 'Completed 12th standard from CMA Hr Sec School, Satna (M.P), India - CBSE Board. Scored <strong>71%</strong>.',
            position: 300,
            curveX: 230, // X position on curve
            image: '/images/cma_campus.jpg',
        },
        {
            year: '2022-2026',
            title: 'BTech in Computer Science',
            description: 'Pursuing Bachelor of Technology in Computer Science Engineering (CSE) from Vindhya Institute of Technology and Science, Satna (M.P), India. Current CGPA: <strong>7.5</strong>',
            position: 550,
            curveX: 212, // X position on curve 
            image: '/images/VITS_campus.jpg',
        },
        {
            year: 'Present',
            title: 'Full-Stack Developer',
            description: 'Building modern web applications with <strong>MERN Stack</strong>. Passionate about creating products that solve real problems and deliver exceptional user experiences.',
            position: 800,
            curveX: 238,
            isPresent: true, // Special flag for current status
        },
    ];

    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

    return (
        <div className="framer-jawn3D">
            <div className="framer-1bovh3h">
                {/* Left Container - Image */}
                <div className="framer-background-image-wrapper">
                    <div className="framer-background-image" />

                    {/* Mobile Hamburger Button */}
                    <button
                        className={`hamburger-menu ${isMenuOpen ? 'open' : ''}`}
                        onClick={toggleMenu}
                        aria-label="Toggle menu"
                    >
                        <span></span>
                        <span></span>
                        <span></span>
                    </button>

                    {/* Navigation Menu */}
                    <div className={`framer-reddsh-container ${isMenuOpen ? 'mobile-open' : ''}`}>
                        <motion.div
                            className="framer-1lfvum"
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            transition={{ duration: 0.5 }}
                        >
                            <div className="framer-myh0-container">
                                <nav className="framer-v3Xal">
                                    <a href="#home" className="framer-text nav-link" onClick={() => setIsMenuOpen(false)}>
                                        <TextScramble>Home</TextScramble>
                                    </a>
                                    <a href="#about" className="framer-text nav-link" onClick={() => setIsMenuOpen(false)}>
                                        <TextScramble>About</TextScramble>
                                    </a>
                                    <a href="#projects" className="framer-text nav-link" onClick={() => setIsMenuOpen(false)}>
                                        <TextScramble>Projects</TextScramble>
                                    </a>
                                    <a href="#opensource" className="framer-text nav-link" onClick={() => setIsMenuOpen(false)}>
                                        <TextScramble>Open Source</TextScramble>
                                    </a>
                                    <a href="#contact" className="framer-text nav-link" onClick={() => setIsMenuOpen(false)}>
                                        <TextScramble>Contact</TextScramble>
                                    </a>
                                </nav>
                            </div>
                        </motion.div>

                        {/* Mobile Menu Close Overlay */}
                        {isMenuOpen && <div className="menu-overlay-bg" onClick={toggleMenu}></div>}
                    </div>
                </div>

                {/* Title - Split Across Both Sides - Moved here for better mobile stacking */}
                <motion.div
                    className="framer-title-left"
                    initial={{ opacity: 0, x: -20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.6, delay: 0.2 }}
                >
                    <h1 className="framer-text framer-styles-preset-16ym2z3 white-text">
                        FULL-STACK
                    </h1>
                </motion.div>

                <motion.div
                    className="framer-title-right"
                    initial={{ opacity: 0, x: 20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.6, delay: 0.4 }}
                >
                    <h1 className="framer-text framer-styles-preset-16ym2z3 black-text">
                        DEVELOPER
                    </h1>
                </motion.div>

                {/* Right Container - White Background */}
                <div className="framer-1jfvum-container">
                    {/* Bio - Bottom Right */}
                    <motion.div
                        className="framer-paragraph-container"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.6, delay: 0.4 }}
                    >
                        <p className="framer-text framer-paragraph">
                            <div className="bio-line-with-dot">
                                <div className="heartbeat-dot"></div>
                                <span className="bio-name-text">I'm Pragyanshu Tiwari.</span>
                            </div>
                            <span className="bio-desc-text">
                                I build high-performing web applications
                                <br />
                                that launch fast, scale seamlessly, and deliver impact.
                            </span>
                        </p>
                    </motion.div>

                    {/* Animated Scroll Indicator */}
                    <motion.div
                        className="scroll-indicator"
                        initial={{ opacity: 0, y: -10 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.8, delay: 0.8 }}
                        onClick={() => {
                            const timeline = document.querySelector('.scroll-timeline-container');
                            if (timeline) {
                                timeline.scrollIntoView({ behavior: 'smooth' });
                            }
                        }}
                    >
                        <div className="scroll-text">Scroll to explore</div>
                        <div className="scroll-arrow">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path d="M12 5V19M12 19L5 12M12 19L19 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </div>
                    </motion.div>
                </div>
            </div>

            {/* Scroll Timeline Section */}
            <ScrollTimeline events={timelineEvents} />

            {/* Tech Stack Marquee Section */}
            <TechMarquee />

            {/* Projects Showcase Section */}
            <ProjectsShowcase />
        </div>
    );
}

export default Portfolio;